<template>
  <div>
    <PCNavbar />
    <MobileNavBar />
    <ExperienceForm />
    <CallMe/>
    <MobileCallme/>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import ExperienceForm from '@/components/experience'
import CallMe from '@/components/callme/index'
import MobileCallme from "@/components/callme/MobileCallme.vue";
export default {
  components: {
    MobileCallme,
    PCNavbar,
    MobileNavBar,
    ExperienceForm,
    CallMe,
  },
}
</script>

<style>
</style>